import { createFileRoute, redirect } from '@tanstack/react-router'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/cash-sales/$cashSaleId/edit')({
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad: ({ context, params, search }) => {
    if (!hasGrant(context.queryClient, 'accounting_cash_sale.edit'))
      throw redirect({ to: '/accounting/sales-receipts', search })
    throw redirect({
      to: '/accounting/sales-receipts/$cashSaleId/edit',
      params: { cashSaleId: params.cashSaleId },
      search,
    })
  },
  component: () => null,
})
